module.exports = __webpack_public_path__ + "assets/img/18_1851_big.b80b0c8b.jpg";